module.exports = __webpack_public_path__ + "img/FI23862826.7f8801a2.png";